import { Autocomplete, CircularProgress, Grid, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import React from "react";

function SelectTemplate({ formData, templates, templatesLoading }) {
  const { values, errors, touched, setFieldValue } = formData;
  const { template: templateV } = values;

  return (
    <MDBox>
      <MDBox>
        <Grid container spacing={3} p={1}>
          <Grid item xs={12} sm={12}>
            <MDBox>
              <MDTypography variant="h5" fontWeight="bold">
                Select Template
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              fullWidth
              variant="standard"
              id="type"
              disableClearable
              value={templateV || null}
              options={templates}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              getOptionLabel={(option) => option?.name}
              renderOption={(props, option) => (
                <Stack {...props} direction="row" px={2} py={1} alignItems="center" spacing={1}>
                  <MDBox sx={{ background: option?.color, height: "30px", width: "5px" }} />

                  <MDTypography sx={{ fontSize: "16px" }}>{option.name}</MDTypography>
                </Stack>
              )}
              onChange={(_, value) => {
                setFieldValue(`template`, value);
              }}
              renderInput={(params) => (
                <MDInput
                  {...params}
                  placeholder="Template"
                  variant="standard"
                  error={touched?.template && Boolean(errors?.template)}
                  helperText={touched?.template && errors?.template}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {templatesLoading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default SelectTemplate;
